import ArrowDown from './arrow-down.jsx';
import ArrowLeft from './arrow-left.jsx';
import ArrowRight from './arrow-right.jsx';
import ArrowSquareOut from './arrow-square-out.jsx';
import ArrowUp from './arrow-up.jsx';
import ArrowsCounterClockwise from './arrows-counter-clockwise.jsx';
import ArrowsDownUp from './arrows-down-up.jsx';
import ArrowsInSimple from './arrows-in-simple.jsx';
import ArrowsLeftRight from './arrows-left-right.jsx';
import ArrowsOutSimple from './arrows-out-simple.jsx';
import BellFill from './bell-fill.jsx';
import BookmarkSimpleFill from './bookmark-simple-fill.jsx';
import BookmarkSimple from './bookmark-simple.jsx';
import CalendarBlank from './calendar-blank.jsx';
import CaretCircleDownFill from './caret-circle-down-fill.jsx';
import CaretCircleDown from './caret-circle-down.jsx';
import CaretCircleUpFill from './caret-circle-up-fill.jsx';
import CaretCircleUp from './caret-circle-up.jsx';
import CaretDownFill from './caret-down-fill.jsx';
import CaretDown from './caret-down.jsx';
import CaretLeft from './caret-left.jsx';
import CaretRight from './caret-right.jsx';
import CaretUpFill from './caret-up-fill.jsx';
import CaretUp from './caret-up.jsx';
import ChatsFill from './chats-fill.jsx';
import CheckCircleFill from './check-circle-fill.jsx';
import CheckCircle from './check-circle.jsx';
import CheckSquare from './check-square.jsx';
import Check from './check.jsx';
import DotsThreeOutlineFill from './dots-three-outline-fill.jsx';
import DownloadSimple from './download-simple.jsx';
import EnvelopeSimple from './envelope-simple.jsx';
import EyeFill from './eye-fill.jsx';
import EyeSlashFill from './eye-slash-fill.jsx';
import Facebook from './facebook.jsx';
import Files from './files.jsx';
import FloppyDiskFill from './floppy-disk-fill.jsx';
import FolderFill from './folder-fill.jsx';
import Folder from './folder.jsx';
import FunnelSimple from './funnel-simple.jsx';
import GearSixFill from './gear-six-fill.jsx';
import Globe from './globe.jsx';
import HouseFill from './house-fill.jsx';
import InfoFill from './info-fill.jsx';
import Info from './info.jsx';
import Instagram from './instagram.jsx';
import Link from './link.jsx';
import Linkedin from './linkedin.jsx';
import List from './list.jsx';
import LockKeyFill from './lock-key-fill.jsx';
import LockKeyOpenFill from './lock-key-open-fill.jsx';
import MagnifyingGlass from './magnifying-glass.jsx';
import MinusCircleFill from './minus-circle-fill.jsx';
import MinusCircle from './minus-circle.jsx';
import Paperclip from './paperclip.jsx';
import PauseCircleFill from './pause-circle-fill.jsx';
import PauseCircle from './pause-circle.jsx';
import PauseFill from './pause-fill.jsx';
import PencilSimpleLineFill from './pencil-simple-line-fill.jsx';
import PhoneFill from './phone-fill.jsx';
import PlayCircleFill from './play-circle-fill.jsx';
import PlayCircle from './play-circle.jsx';
import PlayFill from './play-fill.jsx';
import PlusCircleFill from './plus-circle-fill.jsx';
import PlusCircle from './plus-circle.jsx';
import Plus from './plus.jsx';
import Prohibit from './prohibit.jsx';
import QuestionFill from './question-fill.jsx';
import Question from './question.jsx';
import QuotesFill from './quotes-fill.jsx';
import RadioButtonFill from './radio-button-fill.jsx';
import SpeakerSimpleHighFill from './speaker-simple-high-fill.jsx';
import SpeakerSimpleNoneFill from './speaker-simple-none-fill.jsx';
import SpeakerSimpleSlashFill from './speaker-simple-slash-fill.jsx';
import StarFill from './star-fill.jsx';
import Star from './star.jsx';
import TrashSimpleFill from './trash-simple-fill.jsx';
import TwitterLogoFill from './twitter-logo-fill.jsx';
import UploadSimple from './upload-simple.jsx';
import UserCircleFill from './user-circle-fill.jsx';
import UserFill from './user-fill.jsx';
import WarningCircleFill from './warning-circle-fill.jsx';
import WarningCircle from './warning-circle.jsx';
import WarningFill from './warning-fill.jsx';
import Warning from './warning.jsx';
import XCircleFill from './x-circle-fill.jsx';
import XCircle from './x-circle.jsx';
import X from './x.jsx';
import Youtube from './youtube.jsx';

export default {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowSquareOut,
  ArrowUp,
  ArrowsCounterClockwise,
  ArrowsDownUp,
  ArrowsInSimple,
  ArrowsLeftRight,
  ArrowsOutSimple,
  BellFill,
  BookmarkSimpleFill,
  BookmarkSimple,
  CalendarBlank,
  CaretCircleDownFill,
  CaretCircleDown,
  CaretCircleUpFill,
  CaretCircleUp,
  CaretDownFill,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUpFill,
  CaretUp,
  ChatsFill,
  CheckCircleFill,
  CheckCircle,
  CheckSquare,
  Check,
  DotsThreeOutlineFill,
  DownloadSimple,
  EnvelopeSimple,
  EyeFill,
  EyeSlashFill,
  Facebook,
  Files,
  FloppyDiskFill,
  FolderFill,
  Folder,
  FunnelSimple,
  GearSixFill,
  Globe,
  HouseFill,
  InfoFill,
  Info,
  Instagram,
  Link,
  Linkedin,
  List,
  LockKeyFill,
  LockKeyOpenFill,
  MagnifyingGlass,
  MinusCircleFill,
  MinusCircle,
  Paperclip,
  PauseCircleFill,
  PauseCircle,
  PauseFill,
  PencilSimpleLineFill,
  PhoneFill,
  PlayCircleFill,
  PlayCircle,
  PlayFill,
  PlusCircleFill,
  PlusCircle,
  Plus,
  Prohibit,
  QuestionFill,
  Question,
  QuotesFill,
  RadioButtonFill,
  SpeakerSimpleHighFill,
  SpeakerSimpleNoneFill,
  SpeakerSimpleSlashFill,
  StarFill,
  Star,
  TrashSimpleFill,
  TwitterLogoFill,
  UploadSimple,
  UserCircleFill,
  UserFill,
  WarningCircleFill,
  WarningCircle,
  WarningFill,
  Warning,
  XCircleFill,
  XCircle,
  X,
  Youtube,
};
